import React, { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown } from 'semantic-ui-react';

const DurationPredefinedComponent = (props) => {
    const { input, sign, setDurationValue, setCustomFieldIsVisible, onDurationChange, predefinedValues } = props;
    const { t } = useTranslation();

    const normalizer = useCallback(value => {
        if (!value)
            return value;

        value = value.replace(/([+-])/g, '');

        if (sign === '-') {
            value = '-' + value;
        }

        return value;
    }, [sign]);

    useEffect(() => {
        setDurationValue(normalizer(input.value));
    // redux-form input identity changes every render; sync value only
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [input.value]);

    useEffect(() => {
        const normalized = normalizer(input.value);
        if (normalized !== input.value)
            input.onChange(normalized);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sign]);

    const onChange = (e, data) => {
        const value = data.value === 'custom' ? normalizer('PT0M') : data.value;
        input.onChange(value);
        setCustomFieldIsVisible(data.value === 'custom');
        onDurationChange && onDurationChange(value);
    }

    const options = (predefinedValues || []).map(v => ({
        text: v.text,
        key: v.value,
        value: normalizer(v.value)
    }));
    options.unshift({ text: t('common.duration.custom'), key: -1, value: 'custom' });
    options.unshift({ text: t('common.duration.none'), key: 0, value: null});

    const normalizedValue = normalizer(input.value);
    const predefinedValuesList = options.map(v => v.value);
    const selectedValue = (
        normalizedValue === null || typeof normalizedValue === 'undefined' || normalizedValue === ''
    ) ? null : (
        predefinedValuesList.includes(normalizedValue) ? normalizedValue : 'custom'
    );

    return <Dropdown
        name={ input.name }
        className="form-control"
        options={ options }
        value={ selectedValue }
        onChange={ onChange }
        placeholder={ t('common.duration.none') }
        search
        selection
    />;
}

export default DurationPredefinedComponent;
